export const tipoHistoricoNome = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'COMPRA':
      return 'Compra';
    case 'MANUTENCAO':
      return 'Manutenção';
    case 'REPASSE':
      return 'Repasse';
    case 'VENDA_TROCA':
      return 'Venda/Troca';
    case 'SUCATA':
      return 'Sucata';
    default:
      return tipoHistorico;
  }
};

export const ordernarPorDataHistorico = (a, b) =>
  b.dataHistorico.localeCompare(a.dataHistorico);

const listOrNull = (value) => (Array.isArray(value) && value.length ? value : null);

const scalarOrList = (list, scalar) => list || (scalar ? [String(scalar)] : null);

export const buildEquipamentoFilter = (filterData) => {
  const {
    codigo,
    modelos,
    modelo,
    tipoEquipamento,
    tipoEquipamentos,
    numPatrimonio,
    numPatrimonios,
    numSerie,
    numSeries,
    codigoSisant,
    codigoSisants,
    sisant,
    colaborador,
    colaboradores,
    ...rest
  } = filterData;
  const modelosList = Array.isArray(modelos) && modelos.length
    ? modelos
    : (modelo || codigo ? [modelo || codigo] : null);
  const tipos = scalarOrList(listOrNull(tipoEquipamentos), tipoEquipamento);
  const patrimonios = scalarOrList(listOrNull(numPatrimonios), numPatrimonio);
  const series = scalarOrList(listOrNull(numSeries), numSerie);
  const sisants = scalarOrList(listOrNull(codigoSisants), codigoSisant || sisant);
  const colaboradoresList = scalarOrList(listOrNull(colaboradores), colaborador);

  return {
    ...rest,
    modelos: modelosList,
    tipoEquipamentos: tipos,
    tipoEquipamento: tipos && tipos.length === 1 ? tipos[0] : null,
    numPatrimonios: patrimonios,
    numPatrimonio: patrimonios && patrimonios.length === 1 ? patrimonios[0] : null,
    numSeries: series,
    numSerie: series && series.length === 1 ? series[0] : null,
    codigoSisants: sisants,
    codigoSisant: sisants && sisants.length === 1 ? sisants[0] : null,
    sisant: sisants && sisants.length === 1 ? sisants[0] : null,
    colaboradores: colaboradoresList,
    colaborador: colaboradoresList && colaboradoresList.length === 1 ? colaboradoresList[0] : null,
  };
};

const filled = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  return value != null && String(value).trim() !== '';
};

/** Filtros que pedem unidade individual → lista flat paginada. */
export const isFiltroIdentidade = (filter) => Boolean(
  filled(filter?.numPatrimonio)
  || filled(filter?.numPatrimonios)
  || filled(filter?.numSerie)
  || filled(filter?.numSeries)
  || filled(filter?.colaborador)
  || filled(filter?.colaboradores)
  || filled(filter?.sisant)
  || filled(filter?.codigoSisant)
  || filled(filter?.codigoSisants),
);

export const grupoEquipamentoId = (row) =>
  `${row.tipoEquipamento || ''}::${row.modelo || ''}`;

/** Contagens do grouped: com Eletropontes vs com colaborador. */
export const getPosseContagens = (row) => {
  const comEmpresa = Number(row?.contagemComEletropontes ?? 0);
  const comColaborador = Number(row?.contagemComColaborador ?? 0);
  return { comEmpresa, comColaborador };
};

/**
 * Posse atual da unidade.
 * Prefere `posseEletropontes` do BE; senão deriva de `ultimoRepasse`
 * (ex.: "Devolução - Está com Eletropontes" / "Entrega - Nome").
 * Sem repasse → com a empresa (mesma regra do filtro BE).
 */
export const isUnidadeComEletropontes = (unidade) => {
  if (typeof unidade?.posseEletropontes === 'boolean') {
    return unidade.posseEletropontes;
  }
  const repasse = String(unidade?.ultimoRepasse || '').trim();
  if (!repasse || repasse === '—') {
    return true;
  }
  if (/eletropontes/i.test(repasse)) {
    return true;
  }
  if (/^entrega\b/i.test(repasse)) {
    return false;
  }
  if (/^devolu[cç][aã]o\b/i.test(repasse)) {
    return true;
  }
  return true;
};

/**
 * @param {Array} unidades
 * @param {boolean|null} comEletropontes — null = todas
 */
export const filterUnidadesByPosse = (unidades, comEletropontes) => {
  const list = unidades || [];
  if (comEletropontes == null) return list;
  return list.filter((u) => isUnidadeComEletropontes(u) === comEletropontes);
};
